import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Input } from '@/components/ui/input';

const COUNTRY_CODES = [
  { code: '+1', label: 'US/CA +1', flag: '' },
  { code: '+44', label: 'UK +44', flag: '' },
  { code: '+91', label: 'IN +91', flag: '' },
  { code: '+86', label: 'CN +86', flag: '' },
  { code: '+234', label: 'NG +234', flag: '' },
  { code: '+63', label: 'PH +63', flag: '' },
  { code: '+92', label: 'PK +92', flag: '' },
  { code: '+880', label: 'BD +880', flag: '' },
  { code: '+977', label: 'NP +977', flag: '' },
  { code: '+94', label: 'LK +94', flag: '' },
  { code: '+971', label: 'AE +971', flag: '' },
  { code: '+966', label: 'SA +966', flag: '' },
  { code: '+82', label: 'KR +82', flag: '' },
  { code: '+81', label: 'JP +81', flag: '' },
  { code: '+49', label: 'DE +49', flag: '' },
  { code: '+33', label: 'FR +33', flag: '' },
  { code: '+61', label: 'AU +61', flag: '' },
  { code: '+55', label: 'BR +55', flag: '' },
  { code: '+52', label: 'MX +52', flag: '' },
  { code: '+27', label: 'ZA +27', flag: '' },
  { code: '+254', label: 'KE +254', flag: '' },
  { code: '+233', label: 'GH +233', flag: '' },
  { code: '+20', label: 'EG +20', flag: '' },
  { code: '+60', label: 'MY +60', flag: '' },
  { code: '+65', label: 'SG +65', flag: '' },
  { code: '+353', label: 'IE +353', flag: '' },
  { code: '+64', label: 'NZ +64', flag: '' },
];

export default function PhoneInput({ value, onChange, countryCode, onCountryCodeChange, id, 'data-testid': testId }) {
  return (
    <div className="flex gap-2">
      <Select value={countryCode || '+1'} onValueChange={onCountryCodeChange}>
        <SelectTrigger className="w-[100px] shrink-0" data-testid={testId ? `${testId}-code` : 'phone-code-select'}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {COUNTRY_CODES.map(cc => (
            <SelectItem key={cc.code} value={cc.code}>
              {cc.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        id={id}
        type="tel"
        value={value}
        onChange={onChange}
        placeholder="Phone number"
        className="flex-1"
        data-testid={testId || 'phone-input'}
      />
    </div>
  );
}
